import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { INotificationActionResult } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { ITranslationUploadState, getInitialTranslationUploadState, ITranslationUploadError } from "./TranslationUpload.state";

const initialState = getInitialTranslationUploadState();

export const translationUploadManager = createSlice({
  name: "translationUpload",
  initialState: initialState,
  reducers: {
    uploadTranslation: (state: ITranslationUploadState, _action: PayloadAction<File[]>) => {
      return {
        ...state,
        uploadProcessing: true,
        uploadCompleted: false,
        notifications: [],
        error: undefined,
        progress: 1
      };
    },
    uploadTranslationProcessing: (state: ITranslationUploadState, action: PayloadAction<number>) => {
      return {
        ...state,
        progress: action.payload
      };
    },
    resetUploadingTranslation: () => {
      return initialState;
    },
    uploadTranslationCompleted: (state: ITranslationUploadState) => {
      return {
        ...state,
        uploadProcessing: false,
        uploadCompleted: true
      };
    },
    uploadTranslationFailed: (state: ITranslationUploadState, action: PayloadAction<INotificationActionResult<ITranslationUploadError>>) => {
      return {
        ...state,
        progress: 0,
        uploadProcessing: false,
        uploadCompleted: true,
        notifications: action.payload.notification ? [action.payload.notification] : [],
        error: action.payload.data
      };
    },
    uploadTranslationError: (state: ITranslationUploadState, action: PayloadAction<INotification>) => {
      return { ...state, progress: 0, uploadProcessing: false, notifications: [action.payload] };
    }
  },
  extraReducers: getScreenExtraReducers<ITranslationUploadState>("notifications", initialState)
});
